/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { LABEL_KEY } from '../../wireframes/WireframeBase';
import { InputField, type InputFieldProps } from './InputField';

type LabelProps = Omit<InputFieldProps, 'textKey' | 'item' | 'onChange'>;

export const Label: CanvaSXFC<LabelProps> = function (props) {
  const { wireframe } = props;
  const { label } = wireframe;

  return (
    <InputField
      textKey={LABEL_KEY}
      item={label}
      onChange={value => wireframe.setLabelValue(value)}
      {...props}
    />
  );
};
